export enum SelectAssetRoutes {
  Search = '/select/search',
}
